const ConversionFactorsConfig = {
  collection: "conversion_factors",
  single: true,
  fields: [
    "date_updated",
    "locale.tec_per_page_conversion_factor",
    "locale.emissions_avoided_conversion_factor",
    "locale.saved_trees_conversion_factor",
    "locale.smartphones_charged_conversion_factor",
    "locale.languages_code"
  ],

  adapter: class ConversionFactors {
    constructor(conversionFactors) {
      Object.assign(this, conversionFactors);
      this.locale = (this.locale || []).reduce((acc, locale) => {
        acc[locale.languages_code] = {
          ...locale,
          tec_per_page_conversion_factor: Number.parseFloat(
            locale.tec_per_page_conversion_factor || 0
          ),
          emissions_avoided_conversion_factor: Number.parseFloat(
            locale.emissions_avoided_conversion_factor || 0
          ),
          saved_trees_conversion_factor: Number.parseFloat(
            locale.saved_trees_conversion_factor || 0
          ),
          smartphones_charged_conversion_factor: Number.parseFloat(
            locale.smartphones_charged_conversion_factor || 0
          )
        };
        return acc;
      }, {});
    }
  }
};

export default ConversionFactorsConfig;
